export default __webpack_public_path__ + "static/media/avatar-bts-jungkook.a9b41a76.png";